/* eslint-disable react/prop-types */
import React from 'react';
import styled from 'styled-components';
import WelcomeBody from './WelcomeBody';
import ActionItem from '../ActionItem';
import getImg from '../../../Utils/getImg.js';
import { turnColors } from '../../../Utils/ColorUtil';
import { InternationalizationContext } from '../../../../src/Utils/Contexts';
import { getLabelTranslation, TString } from '../Response/Utils';

const CustomWelcomeBody = styled(WelcomeBody)`
  background: #fff;
  color: #000;
  padding: 0 0 30px 0;
  overflow: auto;
`;
function generateColors(primaryColor) {
  return `linear-gradient(to left, 
				${primaryColor} , 
				${turnColors(primaryColor, { r: 54, g: 63, b: 67 })} 75%,
				${turnColors(primaryColor, { r: 58, g: 78, b: 78 })} 96%
			)`;
}

const WelcomeScreenHeader = styled.div`
  min-height: 50%;
  padding: 20px 0;
  text-align: center;
  border-bottom-left-radius: 13px;
  border-bottom-right-radius: 13px;
  background-image: ${props => generateColors(props.data.primaryColor)};
  z-index: 9;
`;

const WelcomeText = styled.div`
  font-size: 21px;
  margin: 20px 0;
  text-align: center;
  color: rgba(0, 0, 0, 0.68);

  & div:not(:first-child) {
    font-size: 19px;
    font-weight: bold;
  }
`;
const StyledGreeting = styled.div`
  padding: 0 15%;
`;

const QuickLinksBlock = styled.div`
  display: flex;
  justify-content: center;
  flex-flow: row wrap;
  padding: 10px 30px;
`;

const CustomQuickLink = styled.div`
  margin-right: ${80 / 6}px;
  padding: 6px 10px;
  border: 1px solid #b0b4a9;
  border-radius: 4px;
  margin-bottom: 15px;

  & > div {
    font-size: 13px;
    border: 0;
    border-radius: 0;
    background: transparent;
    margin: 0;
    padding: 0;
    color: rgba(0, 0, 0, 0.71);
  }

  & > div:hover {
    background: transparent;
    color: rgba(0, 0, 0, 0.71);
    animation: none;
  }
`;

const Theme3 = props => {
  if (!props.showWelcomeScreen) {
    return null;
  }
  const intlContext = React.useContext(InternationalizationContext);
  const quickLinks = JSON.parse(props.data.quicklinks);
  return (
    <CustomWelcomeBody {...props}>
      <WelcomeScreenHeader {...props}>
        <img
          src={getImg(`welcomeScreen/${props.theme}/1.svg`)}
          alt={TString({ labelName: 'botIconLabel' })}
        />
        <br />
        <img
          src={getImg(`welcomeScreen/${props.theme}/2.svg`)}
          alt={TString({ labelName: 'shadowLabel' })}
        />
      </WelcomeScreenHeader>
      <WelcomeText>
        {props.data.welcomeMessage ? (
          <StyledGreeting> {props.data.welcomeMessage} </StyledGreeting>
        ) : null}
      </WelcomeText>
      <QuickLinksBlock>
        {quickLinks.map((e, i) => {
          return (
            <CustomQuickLink key={i}>
              <ActionItem
                actionLabel={getLabelTranslation(
                  e,
                  intlContext.currentLanguage,
                  'linkText'
                )}
                actionValue={getLabelTranslation(
                  e,
                  intlContext.currentLanguage,
                  'linkValue'
                )}
                handleSubmit={props.handleSubmit}
              ></ActionItem>
            </CustomQuickLink>
          );
        })}
      </QuickLinksBlock>
    </CustomWelcomeBody>
  );
};

export default Theme3;
